import React from 'react';

interface InfoColumnProps {
  content: string;
  propertyName: string;
}

export const InfoColumn = ({ content, propertyName }: InfoColumnProps) => {
  return (
    <div className='l-footer-content-column'>
      <section
        data-epi-property-name={propertyName}
        data-epi-use-mvc='true'
        className='c-info-column'
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};
